"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageWithSelect = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var Types_1 = require("@CommonFrontendBackend/Account/Types");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var PromptTypes_1 = require("@CommonFrontend/Prompt/PromptTypes");
var PromptInline_1 = require("Common/Prompt/PromptInline");
var TemplatesSelector_1 = require("Common/Templates/TemplatesSelector");
var TagsSelector_1 = require("Common/PageFilters/TagsSelector");
var BemBuilder_1 = __importDefault(require("@CommonFrontend/Utils/BemBuilder"));
var UsePageCollection_1 = require("SettingsAngular/Reports/PageCollection/UsePageCollection");
var Types_2 = require("Reports/Types");
var AdminOnly_1 = require("Utils/AdminOnly");
var Types_3 = require("SettingsAngular/Reports/Types");
var c = (0, BemBuilder_1.default)("page-set-filter-content");
function ReportsPageSetFilter(_a) {
    var _b;
    var currentPageFilter = _a.currentPageFilter, selectedPageCollection = _a.selectedPageCollection, handlePageFilterChange = _a.handlePageFilterChange, handlePageCollection = _a.handlePageCollection, isMobile = _a.isMobile;
    var onSelectCollection = function (pageCollection) {
        handlePageCollection(pageCollection);
        handlePageFilterChange(pageCollection.pageFilter, true);
    };
    function onFilterChange(filterChange) {
        handlePageCollection(null);
        handlePageFilterChange(__assign(__assign({}, currentPageFilter), filterChange));
    }
    function clearFilters() {
        onFilterChange(Types_2.NONE_PAGE_FILTER);
    }
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)(c(), (_b = {},
            _b["".concat(c("", "mobile"))] = isMobile,
            _b)) },
        react_1.default.createElement(kaleidoscope_1.Text, { size: "xs" }, "A Collection is a group of Pages with filters for reporting."),
        react_1.default.createElement(kaleidoscope_1.Text, { size: "m", strong: true }, "Select Collection"),
        react_1.default.createElement(SelectCollection, { selectedPageCollection: selectedPageCollection, onSelectCollection: onSelectCollection, clearFilters: clearFilters }),
        react_1.default.createElement(kaleidoscope_1.OptionMenuSeparator, null),
        react_1.default.createElement(kaleidoscope_1.Text, { size: "m", strong: true }, "Page filters"),
        react_1.default.createElement(TemplatesSelector_1.TemplatesSelector, { selectedTemplates: currentPageFilter.templateIds, setSelectedTemplates: function (newSelection) { return onFilterChange({ templateIds: newSelection }); } }),
        react_1.default.createElement(TagsSelector_1.TagsSelector, { selectedTags: currentPageFilter.tags, setSelectedTags: function (newSelection) { return onFilterChange({ tags: newSelection }); } }),
        react_1.default.createElement(PageWithSelect, { selectedPageWidth: currentPageFilter.pageWith, onSelect: function (value) { return onFilterChange({ pageWith: value }); } }),
        react_1.default.createElement(PromptInline_1.PromptInline, { className: c("dialog"), promptId: PromptTypes_1.PromptId.ArchivedPagesExplanation, theme: kaleidoscope_1.AlertTheme.Light, heading: "Archived pages", headingIcon: react_1.default.createElement("div", { className: c("prompt-icon") },
                react_1.default.createElement(icons_1.Warning, null)), content: "Archived pages don't show up in Reports, unless you're looking at a reporting period when the Page was not yet archived." }),
        react_1.default.createElement(AdminOnly_1.AdminOnly, null,
            react_1.default.createElement(kaleidoscope_1.Text, { size: "xs", className: c("create-link") },
                react_1.default.createElement(kaleidoscope_1.Link, { href: "/#/settings/reporting#".concat(Types_3.AnalyticsSettingSectionId.Collection) }, "Create or manage collections")))));
}
var NONE_ID = "none_id";
var SelectCollection = function (_a) {
    var _b;
    var selectedPageCollection = _a.selectedPageCollection, onSelectCollection = _a.onSelectCollection, clearFilters = _a.clearFilters;
    var data = (0, UsePageCollection_1.usePageCollectionData)().data;
    var pageCollections = (_b = data === null || data === void 0 ? void 0 : data.pageCollections) !== null && _b !== void 0 ? _b : [];
    var changeHandler = function (newValue) {
        if (newValue === NONE_ID) {
            clearFilters();
        }
        else {
            onSelectCollection(pageCollections.find(function (_a) {
                var _id = _a._id;
                return _id === newValue;
            }));
        }
    };
    return (react_1.default.createElement(kaleidoscope_1.Select, { autoStack: true, placeholder: "Select an option", label: "Select Collection", value: selectedPageCollection === null || selectedPageCollection === void 0 ? void 0 : selectedPageCollection._id, onChange: changeHandler, size: "m", labelHidden: true, disabled: !data },
        react_1.default.createElement(kaleidoscope_1.SelectOption, { value: NONE_ID, key: NONE_ID }, "(None)"),
        pageCollections.map(function (_a) {
            var _id = _a._id, name = _a.name;
            return (react_1.default.createElement(kaleidoscope_1.SelectOption, { value: _id, key: _id }, name));
        })));
};
function PageWithSelect(_a) {
    var selectedPageWidth = _a.selectedPageWidth, onSelect = _a.onSelect;
    return (react_1.default.createElement(kaleidoscope_1.Select, { autoStack: true, placeholder: "Select an option", label: "Has content", value: selectedPageWidth, onChange: function (value) { return onSelect(value); }, size: "m" }, Object.values(Types_1.PageWithOption).map(function (pageWithValue) { return (react_1.default.createElement(kaleidoscope_1.SelectOption, { value: pageWithValue, key: pageWithValue }, Types_1.PageWithDisplay[pageWithValue])); })));
}
exports.PageWithSelect = PageWithSelect;
exports.default = ReportsPageSetFilter;
